import { useEffect, useState } from 'react'
import { RolodexEntryPutJson } from 'types'

import { RolodexCacheInstance } from './useRolodexCache'

export function useRolodexCachedEntries(
  entries: RolodexEntryPutJson[] | null,
  rolodexCacheInstance: RolodexCacheInstance
) {
  const { putEntry, resetEntry } = rolodexCacheInstance
  const [ids, setIds] = useState<string[]>([])

  useEffect(() => {
    if (entries) {
      const removedIds = ids.filter(
        (mlId) => !entries.map((m) => m.id).includes(mlId)
      )
      removedIds.forEach((mlId) => resetEntry(mlId))
      entries.forEach((ml) => putEntry(ml))
      if (removedIds.length || (!ids.length && entries.length)) {
        setIds(entries.map((ml) => ml.id))
      }
    }
  }, [entries, ids, putEntry, resetEntry])
}
